enum WSStatusMessages {
  NetworkIssues = '[WS] NETWORK_DISCONNECTION',
  AnErrorHasOcurred = '[WS] ERROR_OCURRED',
  RequestTimeout = '[WS] REQUEST_TIMEOUT',
}

export default WSStatusMessages
